import { Link } from "react-router-dom";
const MarketingTabs = (props) => {
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item">
        <Link
          to={"/leaddashboard"}
          className={
            props.pageName === "LEADDASHBOARD"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          LEAD DASHBOARD
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to={"/leads"}
          className={
            props.pageName === "LEAD"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          LEADS
        </Link>
      </li>

      <li className="nav-item" role="presentation">
        <Link
          to={"/leadcalendar"}
          className={
            props.pageName === "APPOINTMENT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          APPOINTMENTS
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/marketing"}
          className={
            props.pageName === "MARKETING"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          MARKETING
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/promotion"}
          className={
            props.pageName === "PROMOTION"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          PROMOTIONS
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/customers"}
          className={
            props.pageName === "CUSTOMERS"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          CUSTOMERS
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to={"/leadreports"}
          className={
            props.pageName === "LEADREPORTS"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          LEAD REPORTS
        </Link>
      </li>
    </ul>
  );
};

export default MarketingTabs;
